import * as React from 'react';
//@ts-ignore
import ProductTile from './../product-tile/./product-tile';
//@ts-ignore
import GridStructure from './../grid-structure/./grid-structure';
//@ts-ignore
import {GetProductsBySlugs} from './../../themes/kent/utilities/dataFunctions';
//@ts-ignore
import ScrollFadeIn from './../scroll-fade/./scroll-fade';


/**
 *
 * Product List component
 * @extends {React.Component}
 */

interface IProps {
  products?: any;
  slugs?:any;
  year?:any;
  alignment?:any;
}

interface IState {
  products?:any;
  slugs?:any;
}

class ProductList extends React.Component<IProps>{

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state ={};
  }
  componentDidMount = async () =>{
    if(this.props.slugs){
      this.fillProductsFromSlugs(this.props.slugs)
    }
    if(this.props.products){
      this.fillProductsFromArray(this.props.products)
    }
  }
  componentDidUpdate = async () =>{
    console.log(this.props.slugs)
    if(!this.props.products && (this.props.slugs != this.state.slugs)){
      this.fillProductsFromSlugs(this.props.slugs)
    }
    if(!this.state.products && this.props.products){
      if(this.props.products != this.state.products){
        this.fillProductsFromArray(this.props.products)
      }
    }
  }

  fillProductsFromSlugs = async(slugs:any) =>{
    let slugArray = slugs;
    if(slugArray){
      if(!Array.isArray(slugArray)){
        slugArray = slugArray.slice()
      }
      console.log(slugArray)
      if(slugArray != this.state.slugs){
        console.log(slugArray)
        let products = await GetProductsBySlugs(slugArray,this.props.year)
        console.log(products)
        if(products){
          this.setState({
            products:products,
            slugs:this.props.slugs
          })
        }
      }
    }
  }

  fillProductsFromArray = (products:any) =>{
    this.setState({
      products:products
    })
  }

  public render(): JSX.Element {
    return (
      <div className="site-gutter">
        <div>
          <GridStructure
            alignment={this.props.alignment}
            columns={3}>
              {this.state.products && this.state.products.map((product:any) =>{
                return (<ScrollFadeIn><ProductTile year={this.props.year} product={product} /></ScrollFadeIn>)
              })}
            </GridStructure>
        </div>
      </div>
    );
  }
}

 export default ProductList;
